import Utility from '../Utility/Utility';

let Utl = new Utility();
let language = Utl.getCookie("appLang");

const optionSocial      = ( language === "en" ? "Social media" : "Redes sociales" );
const optionFbook       = "Facebook";
const optionTwitter     = "Twitter (X)";
const optionInsta       = "Instagram";
const optionYtube       = "Youtube";
const optSelTemplate    = ( language === "en" ? "Select header style" : "Seleccione estilo de página" );
const optStyle_0        = ( language === "en" ? "Style 1" : "Estilo 1" );
const optStyle_1        = ( language === "en" ? "Style 2" : "Estilo 2" );
const optStyle_2        = ( language === "en" ? "Carousel" : "Carrusel" );
const optCarouselImgs   = ( language === "en" ? "Select carousel images" : "Seleccione imágenes del carrusel" );

export const AccountOptions = 
`
<div class='row'>
    <div class='col-md-6'>
        <div class='row'>
            <div class='col-md-12 col-sm-12 text-center'>
                <span class='me-2 d-inline'><i class="far fa-thumbs-up fa-2x"></i></span><h4 class='d-inline'>`+optionSocial+`</h4>
            </div>
        </div>

        <div class='row form-group mt-2'>
            <div class='col-md-4 text-end app-label-input'>
                <span class='me-2 d-inline'><i class="fab fa-facebook"></i></span>`+optionFbook+`
            </div>
            <div class='col-md-8 text-start app-label-input'>
                <input type='text' name='cus_bus_facebook' id='cus_bus_facebook' class='form-control' maxLength="64" />
            </div>
        </div>

        <div class='row form-group mt-2'>
            <div class='col-md-4 text-end app-label-input'>
                <span class='me-2 d-inline'><i class="fab fa-twitter-square"></i></span>`+optionTwitter+`
            </div>
            <div class='col-md-8 text-start app-label-input'>
                <input type='text' name='cus_bus_twitter' id='cus_bus_twitter' class='form-control' maxLength="64" />
            </div>
        </div>

        <div class='row form-group mt-2'>
            <div class='col-md-4 text-end app-label-input'>
                <span class='me-2 d-inline'><i class="fab fa-instagram-square"></i></span>`+optionInsta+`
            </div>
            <div class='col-md-8 text-start app-label-input'>
                <input type='text' name='cus_bus_instagram' id='cus_bus_instagram' class='form-control' maxLength="64" />
            </div>
        </div>

        <div class='row form-group mt-2'>
            <div class='col-md-4 text-end app-label-input'>
                <span class='me-2 d-inline'><i class="fab fa-youtube"></i></span>`+optionYtube+`
            </div>
            <div class='col-md-8 text-start app-label-input'>
                <input type='text' name='cus_bus_youtube' id='cus_bus_youtube' class='form-control' maxLength="64" />
            </div>
        </div>
    </div>
    <div id="appStyles" class='col-md-6'>
        <div class='row'>
            <div class='col-md-12 col-sm-12 text-center'>
                <span class='me-2 d-inline'><i class="far fa-images fa-2x"></i></span><h4 class='d-inline'>`+optSelTemplate+`</h4>
            </div>
        </div>

        <div class='row form-group mt-2 text-center'>
            <div class='col-md-3 col-sm-12 app-label-input'>
                <div class="form-check acct-status-pointer">
                    <input type="hidden" name="cus_bus_template" id="cus_bus_template" value="0" />
                    <input class="form-check-input" type="radio" name="acctStyle" id="acctStyle_0" checked>
                    <label class="form-check-label" for="acctStyle_0">
                        `+optStyle_0+`
                    </label>
                </div>
            </div>
            <div class='col-md-9 col-sm-12'>
                <img id="appTemplate1" loading="lazy" src="" alt="" />
            </div>
        </div>

        <div class='row form-group mt-2 text-center'>
            <div class='col-md-3 col-sm-12 app-label-input'>
                <div class="form-check acct-status-pointer">
                    <input class="form-check-input" type="radio" name="acctStyle" id="acctStyle_1">
                    <label class="form-check-label" for="acctStyle_1">
                        `+optStyle_1+`
                    </label>
                </div>
            </div>
            <div class='col-md-9 col-sm-12'>
                <img id="appTemplate2" loading="lazy" src="" alt="" />
            </div>
        </div>

        <div id="appCarouselStyle" class='row form-group mt-2 text-center'>
            <div class='col-md-3 col-sm-12 app-label-input'>
                <div class="form-check acct-status-pointer">
                    <input class="form-check-input" type="radio" name="acctStyle" id="acctStyle_2">
                    <label class="form-check-label" for="acctStyle_2">
                        `+optStyle_2+`
                    </label>
                </div>
            </div>
            <div class='col-md-9 col-sm-12'>
                <img id="appTemplate3" loading="lazy" src="" alt="" style="height: 5rem;" />
            </div>
        </div>
    </div>
</div>

<div id="appCarouselSection">
    <div class='row mt-2'>
        <div class='col-md-12'>
            <hr />
        </div>
    </div>
    <div class='row'>
        <div class='col-md-12 text-center'>
            <h4>`+optCarouselImgs+`</h4>
        </div>
    </div>

    <div class='row mt-2 app-carousel-img'>
        <input type="hidden" id="current_carousel_img" name="current_carousel_img" />
        <div class='col-md-4 text-center mt-3'>
            <input class="d-none" id="carousel_upload_img_0" name="carousel_upload_img_0" maxLength='64' type="file" accept="image/png, image/jpeg" />
            <input type="hidden" id="cus_bus_carousel_img_0" name="cus_bus_carousel_img_0" />
            <img id="carousel_img_0" name="carousel_img_0" loading="lazy" src="" alt="" />
            <div class="dropdown d-inline">
                <button class="app-ellipsis-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                </button>
                <ul class="dropdown-menu">
                    <li><a id="carousel_from_computer_0" class="dropdown-item" href="#">Select from computer</a></li>
                    <li><a id="carousel_from_samples_0" class="dropdown-item" href="#">Select from samples</a></li>
                </ul>
            </div>
        </div>

        <div class='col-md-4 text-center mt-3'>
            <input class="d-none" id="carousel_upload_img_1" name="carousel_upload_img_1" maxLength='64' type="file" accept="image/png, image/jpeg" />
            <input type="hidden" id="cus_bus_carousel_img_1" name="cus_bus_carousel_img_1" />
            <img id="carousel_img_1" name="carousel_img_1" loading="lazy" src="" alt="" />
            <div class="dropdown d-inline">
                <button class="app-ellipsis-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                </button>
                <ul class="dropdown-menu">
                    <li><a id="carousel_from_computer_1" class="dropdown-item" href="#">Select from computer</a></li>
                    <li><a id="carousel_from_samples_1" class="dropdown-item" href="#">Select from samples</a></li>
                </ul>
            </div>
        </div>

        <div class='col-md-4 text-center mt-3'>
            <input class="d-none" id="carousel_upload_img_2" name="carousel_upload_img_2" maxLength='64' type="file" accept="image/png, image/jpeg" />
            <input type="hidden" id="cus_bus_carousel_img_2" name="cus_bus_carousel_img_2" />
            <img id="carousel_img_2" name="carousel_img_2" loading="lazy" src="" alt="" />
            <div class="dropdown d-inline">
                <button class="app-ellipsis-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                </button>
                <ul class="dropdown-menu">
                    <li><a id="carousel_from_computer_2" class="dropdown-item" href="#">Select from computer</a></li>
                    <li><a id="carousel_from_samples_2" class="dropdown-item" href="#">Select from samples</a></li>
                </ul>
            </div>
        </div>
    </div>

    <div class='row mt-2  app-carousel-img'>
        <div class='col-md-4 text-center mt-3'>
            <input class="d-none" id="carousel_upload_img_3" name="carousel_upload_img_3" maxLength='64' type="file" accept="image/png, image/jpeg" />
            <input type="hidden" id="cus_bus_carousel_img_3" name="cus_bus_carousel_img_3" />
            <img id="carousel_img_3" name="carousel_img_3" loading="lazy" src="" alt="" />
            <div class="dropdown d-inline">
                <button class="app-ellipsis-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                </button>
                <ul class="dropdown-menu">
                    <li><a id="carousel_from_computer_3" class="dropdown-item" href="#">Select from computer</a></li>
                    <li><a id="carousel_from_samples_3" class="dropdown-item" href="#">Select from samples</a></li>
                </ul>
            </div>
        </div>

        <div class='col-md-4 text-center mt-3'>
            <input class="d-none" id="carousel_upload_img_4" name="carousel_upload_img_4" maxLength='64' type="file" accept="image/png, image/jpeg" />
            <input type="hidden" id="cus_bus_carousel_img_4" name="cus_bus_carousel_img_4" />
            <img id="carousel_img_4" name="carousel_img_4" loading="lazy" src="" alt="" />
            <div class="dropdown d-inline">
                <button class="app-ellipsis-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                </button>
                <ul class="dropdown-menu">
                    <li><a id="carousel_from_computer_4" class="dropdown-item" href="#">Select from computer</a></li>
                    <li><a id="carousel_from_samples_4" class="dropdown-item" href="#">Select from samples</a></li>
                </ul>
            </div>
        </div>

        <div class='col-md-4 text-center mt-3'>
            <input class="d-none" id="carousel_upload_img_5" name="carousel_upload_img_5" maxLength='64' type="file" accept="image/png, image/jpeg" />
            <input type="hidden" id="cus_bus_carousel_img_5" name="cus_bus_carousel_img_5" />
            <img id="carousel_img_5" name="carousel_img_5" loading="lazy" src="" alt="" />
            <div class="dropdown d-inline">
                <button class="app-ellipsis-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                </button>
                <ul class="dropdown-menu">
                    <li><a id="carousel_from_computer_5" class="dropdown-item" href="#">Select from computer</a></li>
                    <li><a id="carousel_from_samples_5" class="dropdown-item" href="#">Select from samples</a></li>
                </ul>
            </div>
        </div>
    </div>    
</div>
`;